var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-medical-service.60579a0d.png","uri@2x": __webpack_public_path__ + "icon-medical-service.923e0781.png","uri@3x": __webpack_public_path__ + "icon-medical-service.e13e25ab.png",
    width: 20,
    height: 19
});